TPS.DealerSelfInspection = {
    form: null,
    fields: null,
    dealerCodeInput: null,
    dealerNameInput: null,
    checkboxes: null,
    submitButton: null,
    watermarkClassName: null,
    dealerNamePlaceholder: '',
    dealerNameErrorText: '',
    dealerNameErrorLabel: null,

    init: function (
        formSelector = '.tps-dsi-form',
        fieldSelector = '.tps-dsi-form-field',
        dealerCodeSelector = '.tps-dsi-form-field--dealercode',
        dealerNameSelector = '.tps-dsi-form-field--dealername',
        checkboxSelector = '.tps-dsi-form-field--checkbox input',
        watermarkClassName = 'WatermarkText',
        dealerNamePlaceholder = 'Dealer Name',
        dealerNameErrorText = 'Dealer not found. Please inform a valid code or contact <a href="mailto:aplan@volvocars.com">aplan@volvocars.com</a>.',
        dealerNameErrorSelector = '#dealerNameError') {

        var _this = TPS.DealerSelfInspection;

        _this.form = document.querySelector(formSelector);
        _this.submitButton = document.querySelector(formSelector + ' input[type="submit"]');
        _this.fields = Array.prototype.slice.call(document.querySelectorAll(formSelector + ' ' + fieldSelector));
        _this.dealerCodeInput = document.querySelector(formSelector + ' ' + dealerCodeSelector);
        _this.dealerNameInput = document.querySelector(formSelector + ' ' + dealerNameSelector);
        _this.checkboxes = Array.prototype.slice.call(document.querySelectorAll(formSelector + ' ' + checkboxSelector));
        _this.watermarkClassName = watermarkClassName;
        _this.dealerNamePlaceholder = dealerNamePlaceholder;
        _this.dealerNameErrorText = dealerNameErrorText;
        _this.dealerNameErrorLabel = document.querySelector(formSelector + ' ' + dealerNameErrorSelector);

        if (_this.form && _this.submitButton) {
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Company');

            _this.disableSubmitButton();
            _this.setupFields();
        }
    },

    disableSubmitButton: function () {
        var _this = TPS.DealerSelfInspection;

        _this.submitButton.setAttribute('disabled', 'disabled');
    },

    setupFields: function () {
        var _this = TPS.DealerSelfInspection;

        _this.dealerNameInput.placeholder = _this.dealerNamePlaceholder;
        _this.dealerNameInput.setAttribute('readonly', 'readonly');

        $(_this.fields).on('input change blur', _this.maybeEnableSubmitButton);

        $(_this.dealerCodeInput).on('change', function (e) {
            _this.populateDealerName(_this.dealerCodeInput.value);
        });

        $(_this.dealerCodeInput).on('keydown', function (e) {
            try {
                clearTimeout(window._timerDealerCode);
            } catch (err) { }

            window._timerDealerCode = setTimeout(function () {
                _this.populateDealerName(_this.dealerCodeInput.value);
            }, 1500);
        });

        $(_this.checkboxes).on('change', _this.maybeEnableSubmitButton);
    },

    maybeEnableSubmitButton: function () {
        var _this = TPS.DealerSelfInspection;

        var allFieldsFilled = _this.fields.every(function (field) {
            return _this.isInputFilled(field);
        });

        if (allFieldsFilled && _this.allCheckboxesSelected()) {
            _this.submitButton.removeAttribute('disabled');
        } else {
            _this.disableSubmitButton();
        }
    },

    isInputFilled: function (input) {
        var _this = TPS.DealerSelfInspection;

        return input.value && input.value.trim().length > 0 && !input.classList.contains(_this.watermarkClassName);
    },

    allCheckboxesSelected: function () {
        var _this = TPS.DealerSelfInspection;

        return _this.checkboxes.every(function (checkbox) {
            return checkbox.checked;
        });
    },

    populateDealerName: function (value) {
        var _this = TPS.DealerSelfInspection;

        _this.dealerNameInput.placeholder = 'Loading...';

        CMSApp.AV.API.Company.GetDealershipByCode(value, function (d) {
            if (d.CompanyID > 0 && d.Name) {
                _this.dealerNameInput.value = d.Name;
                _this.dealerNameErrorLabel.innerHTML = '';
            } else {
                _this.dealerNameInput.value = '';
                _this.dealerNameErrorLabel.innerHTML = _this.dealerNameErrorText;
            }
            _this.maybeEnableSubmitButton();
            _this.dealerNameInput.placeholder = _this.dealerNamePlaceholder;
        }, function () {
                _this.dealerNameInput.value = '';
                _this.maybeEnableSubmitButton();
                _this.dealerNameInput.placeholder = _this.dealerNamePlaceholder;
                _this.dealerNameErrorLabel.innerHTML = _this.dealerNameErrorText;
        });
    }
}
